
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { createGraphNodeClicker, BarChart, DashboardGraph } from 'graph'
import { useGraphFetch, constants } from '../module'
import { useSelectedFleetIds } from 'features/settings'
import { v4 as uuid } from 'uuid'

const Graph = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const selectedFleetIds = useSelectedFleetIds()
  const { loading, error, data } = useGraphFetch()
  const path = '/reports/maturities'

  const onClick = createGraphNodeClicker(data?.ranges, (key, value) => {
    if (key && value) {
      dispatch({ type: 'reportUpcomingMaturities_set_dashboard_filter', payload: true })
      navigate(`${path}?${key}=${value}`)
    } else {
      navigate(`${path}?matured=true`)
    }
  })

  const onRefresh = () => {
    dispatch({
      type: constants.REQUEST_DATA,
      payload: null,
      options: { queryParams: { FleetId: selectedFleetIds.join() }, requestId: uuid() }
    })
  }

  return (
    <DashboardGraph
      title="Maturing"
      to={path}
      loading={loading}
      error={error}
      onRefresh={onRefresh}
      data={data}>
      {data && (
        <BarChart
          data={data}
          noDataMessage="You have no deals coming up to maturity in the next 6 months."
          onClick={onClick}/>
      )}
    </DashboardGraph>
  )
}

export default Graph
